import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { DispositionActions } from "./index";
import {
  CLEAR_DISPOSITION,
  CLEAR_DISPOSITION_STATE,
  FETCH_DISPOSITION_FAILED,
  FETCH_DISPOSITION_LIST_FAILED,
  FETCH_DISPOSITION_LIST_PROGRESS,
  FETCH_DISPOSITION_LIST_SUCCESS,
  FETCH_DISPOSITION_PROGRESS,
  FETCH_DISPOSITION_SUCCESS,
} from "./disposition.action";
import { initialDispositionState } from "./disposition.state";

export const dispositionReducer = (
  state: IStoreState["disposition"] = initialDispositionState,
  action: DispositionActions
) => {
  switch (action.type) {
    case FETCH_DISPOSITION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.disposition.list.loading = LoadState.InProgress;
        draftState.disposition.list.list = [];
        draftState.disposition.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_DISPOSITION_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.disposition.list.loading = LoadState.Loaded;
        draftState.disposition.list.list = list;
        draftState.disposition.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_DISPOSITION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.disposition.list.loading = LoadState.Failed;
        draftState.disposition.list.list = [];
        draftState.disposition.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_DISPOSITION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.disposition.data.loading = LoadState.InProgress;
        draftState.disposition.data.data = null;
      });
      return newState;
    }
    case FETCH_DISPOSITION_SUCCESS: {
      const { disposition } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.disposition.data.loading = LoadState.Loaded;
        draftState.disposition.data.data = disposition;
      });
      return newState;
    }
    case FETCH_DISPOSITION_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.disposition.data.loading = LoadState.Failed;
        draftState.disposition.data.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_DISPOSITION: {
      const newState = produce(state, (draftState) => {
        draftState.disposition.data.loading = LoadState.NotLoaded;
        draftState.disposition.data.data = null;
      });
      return newState;
    }
    case CLEAR_DISPOSITION_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.disposition = initialDispositionState.disposition;
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
